import { KatLitFilteredElement, register } from '../../shared/base';
import { KatMetric } from './';

/**
 * @component {kat-metric-control} KatMetricControl Component used to place and filter control components within the metric component.
 */
@register(KatMetric.slotMapping.control.name)
export class KatMetricControl extends KatLitFilteredElement {
  constructor() {
    super(
      KatMetric.slotMapping.control.name,
      KatMetric.slotMapping.control.allowed
    );
  }
}
